/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Modalita\' di revoca del voucher
 */
export enum RevocaVoucherModalita {

    SOLO_NON_SPESO = 'SOLO_NON_SPESO',

    BLOCCA_E_REGISTRA = 'BLOCCA_E_REGISTRA',

    BLOCCA_E_STORNA = 'BLOCCA_E_STORNA'
}

